<template>
  <v-dialog width="600" persistent scrollable v-model="dialog">
    <v-card>
      <v-card-title class="admin white--text text-uppercase">
        Chuyển hồ sơ từ đợt 1
        <v-spacer />
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form ref="form">
          <v-text-field
            v-model="code"
            placeholder="Mã hồ sơ"
            clearable
            flat
            outlined
            dense
            :rules="[$rules.required]"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-6">
        <v-btn color="grey" outlined variant="text" @click="closeDialog"> Huỷ </v-btn>
        <v-spacer />
        <v-btn :loading="loading" color="admin" outlined variant="text" @click="onConfirm"> Xác nhận </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions} from 'vuex'
export default {
  data: () => ({dialog: false, code: '', loading: false}),
  methods: {
    ...mapActions({updateRetry: 'cv/updateRetry'}),
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    async onConfirm() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return this.$alert.error('Vui lòng điền mã học sinh')
      this.loading = true
      try {
        await this.updateRetry({code: this.code, retryNth: 1, type: 'regist'})
        this.$emit('refresh', {code: this.code})
        this.$alert.success(`Đã đăng ký cho hồ sơ ${this.code} thành công!`)
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>